var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.65 44.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-insta-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.33.24a12.11,12.11,0,0,0-10.26,12c0,3.23-.18,19.93.14,22A12.15,12.15,0,0,0,12,44.58c3.24.07,20.21.2,22.27-.15A12,12,0,0,0,44.58,32.59c.07-3.08.15-19.93-.11-22A12.14,12.14,0,0,0,32.68.08C29.54,0,12.5-.08,10.33.24Zm4.11,5.57a9.71,9.71,0,0,0-8.58,8.12,151.58,151.58,0,0,0-.05,16.52A9.9,9.9,0,0,0,14,38.8a146.47,146.47,0,0,0,16.5,0,9.82,9.82,0,0,0,8.31-8.22,147.08,147.08,0,0,0,0-16.4,9.82,9.82,0,0,0-8.21-8.35A141,141,0,0,0,14.44,5.81Zm.32,2.88c-3.91.56-6.1,3.25-6.14,7.58,0,3.61-.37,10.53.09,13.8.52,3.68,3.47,6,7.64,6,3.73,0,10.39.37,13.79-.09C33.91,35.43,36,32.51,36,28.3c0-3.73.39-10.36-.06-13.72-.5-3.67-3.46-5.95-7.58-5.94-3.55,0-10.52-.4-13.62,0Zm5.52,5.51a8.4,8.4,0,0,0,4,16.33A8.46,8.46,0,0,0,30.5,20.27,8.36,8.36,0,0,0,20.28,14.2Zm1.34,2.68C14.35,18,15.83,28.68,23.1,27.8a5.57,5.57,0,0,0,4.69-6.31A5.46,5.46,0,0,0,21.62,16.88Zm8.84-5.17a1.71,1.71,0,0,0-.94,2.5,1.91,1.91,0,1,0,.94-2.5Z",
    transform: "translate(0 0)",
    fill: "#cacaca",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaOff);
export default __webpack_public_path__ + "static/media/insta-off.d206da1add3241888f5b5cfe25421958.svg";
export { ForwardRef as ReactComponent };